/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Modal, { ModalHeader } from "../Modal";
import taxAccountantUsefulSiteToggle from "../../utils/taxAccountantUsefulSite";
import { TAX_ACCOUNTANT_USEFUL_SITES } from "../../constants/TAX_ACCOUNTANT_USEFULE_SITES";

const TaxAccountantUsefulSitePop = ({ isOpen }) => {

  return (
    <Modal
      isOpen={isOpen}
      close={() => { taxAccountantUsefulSiteToggle(); }}
    >
      <div className="item-write">
        <ModalHeader>세무사 유용한 사이트</ModalHeader>
        <div className="tax_accountant-useful-sites-wrap">
          {TAX_ACCOUNTANT_USEFUL_SITES.map((group, idx) => <div className="tax_accountant-useful-sites" key={idx}>
            {group.list.map((site) => <a className="tax_accountant-useful-site" key={site.link} href={site.link} target="_blank">{site.label}</a>)}
          </div>)}
        </div>
      </div>
    </Modal>
  );
};

export default TaxAccountantUsefulSitePop;
